import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, hasSubmitFailed } from 'redux-form';
import { localize } from 'react-localize-redux';

import FlatButton from 'material-ui/FlatButton';

import SurveyQuestion from './surveys/SurveyComponents';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

class SurveyForm extends Component {
  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
        {this.props.surveyQuestions.map((question, index) => {
          return <SurveyQuestion question={question} index={index} />;
        })}

        {this.props.submitFailed && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            {this.props.translate('pleaseFillEntireSurvey')}
          </div>
        )}
        <div>
          <FlatButton
            label={this.props.translate('send')}
            primary={true}
            type="submit"
            disabled={submitting}
            backgroundColor={submitting ? colors.LIGHT_GRAY : AccentColor()}
            hoverColor="grey"
            style={{ color: 'white', margin: '10px 0' }}
          />
        </div>
      </form>
    );
  }
}

SurveyForm = reduxForm({
  form: 'survey_form',
})(SurveyForm);

SurveyForm = connect(state => ({
  submitFailed: hasSubmitFailed('SurveyForm')(state),
}))(SurveyForm);

export default localize()(SurveyForm);
